module.exports = __webpack_public_path__ + "static/img/05.6a35dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/design/assets/05.png
// module id = QKBM
// module chunks = 64